import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { errorToast, successToast } from '../Common/showtoast';
import ApiRequest from '../Common/restservice';
import loginbg from '../Assets/Images/loginbg.jpg';
import logo from '../Assets/Images/logo.png';

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const [theme, setTheme] = useState('light');
    useEffect(() => {
        setTheme(document.body.classList.contains('light-skin') ? "light" : "dark");
        let ele = document.getElementById("root");
        ele.classList.add("h-p100");
        return () => ele.classList.remove("h-p100");
    }, [])
    return (
        <div class="container h-p100"style={{background:`url(${loginbg})`,backgroundSize:'cover',width:'100%',maxWidth:'100%'}}>
            <div class="row align-items-center justify-content-md-center h-p100" style={{backgroundColor:'#efefef4a'}}>

                <div class="col-12">
                    <div class="row justify-content-center g-0">
                        <div class="col-lg-5 col-md-5 col-12">
                            <div class={`${theme === "light" ? "bg-white" : "bg-gray-900"} rounded10 shadow-lg`}>
                                <div class="content-top-agile p-20 pb-0">
                                <img src={logo} style={{height:60,marginBottom:20}} />
                                    <h4 class="mb-1 text-secondary pt-2">Forgot Password? 🔒</h4>
                                    <p class="mb-4 text-fade">Enter your email and we'll send you instructions to reset your password</p>
                                </div>
                                <div class="p-40">
                                    <form id="formAuthentication" class="mb-3" onSubmit={async (e) => {
                                        e.preventDefault();
                                        if (!email) {
                                            errorToast("Enter valid email");
                                            return;
                                        }
                                        let jsoninput = {
                                            username: email,
                                            email
                                        }
                                        let res = await ApiRequest("resetpassword.asp", "POST", jsoninput);
                                        if (res.status === "error") {
                                            errorToast(res.message);
                                            return;
                                        }
                                        successToast(res.message);
                                        navigate("/login");
                                    }}>
                                        <div class="form-group">
                                            <div class="input-group mb-3">
                                                <span class="input-group-text bg-transparent"><i class="text-fade fa fa-envelope"></i></span>
                                                <input type="email" class="form-control ps-15 bg-transparent" placeholder="Your Email" onChange={(e) => {
                                                    setEmail(e.target.value);
                                                }} value={email} />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-12 text-center">
                                                <button class="btn btn-primary">Send Reset Link</button>
                                            </div>
                                        </div>
                                        <div class="text-center mt-3">
                                            <Link to={"/"} class="d-flex align-items-center text-secondary justify-content-center">
                                                <i class="fa fa-chevron-left scaleX-n1-rtl"></i> &nbsp;&nbsp;Back to login
                                            </Link>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword